<template>
  <v-btn
    :disabled="!apps || !apps.length || apps.length !== 1"
    color="blue-grey"
    class="nlp-nav-btn"
    small
    outline
    @click="handleClick"
  >
    <v-icon> south </v-icon>
    Import App
  </v-btn>
</template>

<script>
export default {
  name: "ImportApp",
  props: {
    apps: {
      type: Array,
      required: null,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    handleClick() {
      if (!this.apps || !this.apps.length) return;
      this.importSelectedApps(this.apps);
    },
    async importSelectedApps(apps = this.apps) {
      console.log("apps", apps);
      let i;
      for (i = 0; i < apps.length; i += 1) {
        this.importSingleApp(apps[i]);
      }
    },
    async importSingleApp(app) {
      try {
        const response = await this.$http_nlp.post(
          `/apps/${app.id}/import`,
          {}
        );
        return true;
      } catch (err) {
        throw err;
        return false;
      }
    },
  },
};
</script>

<style lang="css" scoped></style>
